import React, { useState } from 'react';
import "./cssForGallery.css";

const Gallery = () => {
  const images = [
    'https://cdn.discordapp.com/attachments/1209250562894463046/1225618981696700416/Screenshot_2024-04-04_133506.png?ex=6621c9a0&is=660f54a0&hm=708423a36b130ef0d20de08870c9553e03a444823bc2351870a79352d1a70a60&',
    'https://cdn.discordapp.com/attachments/1209250562894463046/1225618982229250189/Screenshot_2024-04-04_133718.png?ex=6621c9a0&is=660f54a0&hm=ce37733cee05e8289e0484c7160f2f6996a8446a591279be108f96aa2fc5ec5a&',
    'https://cdn.discordapp.com/attachments/1209250562894463046/1225618982871240826/Screenshot_2024-04-04_133657.png?ex=6621c9a0&is=660f54a0&hm=dba5cb0112d765dd1973f122248a4663bfb3220084527b449cee4eeaf85a2e0b&',
    'https://cdn.discordapp.com/attachments/1209250562894463046/1225618983596720228/Screenshot_2024-04-04_134132.png?ex=6621c9a0&is=660f54a0&hm=63549b5f212206725af5810b6a50a2b23d198fcbe11327c213dd458c9c59f1fa&',
    'https://cdn.discordapp.com/attachments/1209250562894463046/1225618984225738794/Screenshot_2024-04-04_134200.png?ex=6621c9a0&is=660f54a0&hm=9eaaf246e3f487f7a6bc755c9b67eff947dd32e06c01597305ec19231e72865f&',
    'https://u.osu.edu/belongingtosoil/files/2021/11/flying-ant-view.jpg',
    'https://u.osu.edu/belongingtosoil/files/2021/11/riding-on-flying-ant.jpg',
    'https://u.osu.edu/belongingtosoil/files/2021/11/above-ground.jpg',
    'https://u.osu.edu/belongingtosoil/files/2021/11/waterbear-pond.jpg',
    'https://u.osu.edu/belongingtosoil/files/2021/11/chasing-waterbears.jpg',
    'https://u.osu.edu/belongingtosoil/files/2021/11/portal-to-underground-scene.jpg',
    'https://u.osu.edu/belongingtosoil/files/2021/11/millipede-blocks-the-tunnel.jpg',
    'https://u.osu.edu/belongingtosoil/files/2021/11/through-the-tunnel.jpg',
    'https://u.osu.edu/belongingtosoil/files/2021/11/underground-roots.jpg',
    'https://u.osu.edu/belongingtosoil/files/2021/11/entering-underground-chamber.jpg',
    'https://u.osu.edu/belongingtosoil/files/2021/11/lightmapping-underground.jpg',
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const goToNextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToPreviousImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="gallery-container">
      <div className="text-overlay">Unity VR Game Gallery</div>
      <div className="image-wrapper">
        <img src={images[currentImageIndex]} alt={`${currentImageIndex + 1}`} />
        <button className="arrow left" onClick={goToPreviousImage}>
          &#8249;
        </button>
        <button className="arrow right" onClick={goToNextImage}>
          &#8250;
        </button>
      </div>
    </div>
  );
};

export default Gallery;
